import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AuthenticatedRemoteService
  from '@avtechsoftware/ra-javascript-utilities/src/utilities/authentication/AuthenticatedRemoteService';
import PublicPage from '../PublicPage/PublicPage';
import { PublicContextProvider } from '../../../contexts/PublicContext/PublicContext';

const authenticatedRemoteService = new AuthenticatedRemoteService();
function PublicApp() {
  return (
    <BrowserRouter>
      <PublicContextProvider
        remoteService={authenticatedRemoteService}
      >
        <PublicPage />
      </PublicContextProvider>
    </BrowserRouter>
  );
}

export default PublicApp;
